import { commitmentsSliceSelector } from "./commitmentsSliceSelector";
import { RootState } from "../../store";

export const commitmentsCurrentOrgIdSelector = (state: RootState) => {
  const slice = commitmentsSliceSelector(state);

  return slice.currentOrgId;
};
